// #### HOOKS ####
import { useState, useEffect } from 'react';

// #### CUSTOM HOOKS ####
import { useProducts } from './hooks/useProducts';

// #### COMPONENTS ####
import Products from './components/Products';


const url = "https://produtos-753f5-default-rtdb.firebaseio.com/products";

function App() {

  const classInput = "block px-3 py-1 bg-white text-gray-700 shadow-sm rounded-xl w-full mb-2";

  const [collapse, setCollapse] = useState(false);

  const [products, setProducts] = useState([]);
  const [name, setName]         = useState("");
  const [price, setPrice]       = useState("");

  const { data: dataProducts, loading, error, addProducts, deleteProduct } = useProducts(url);

  // ###  RESGATANDO DADOS ###
  useEffect(() => {
    if (dataProducts) {
      setProducts(dataProducts);
    }
    // console.log("products",products);
  }, [dataProducts,]);

  // ### ADICIONAR DADOS ###
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name || !price) {
      alert("Nome e preço devem ser preenchidos!");
      return;
    }

    // DADOS QUE SERÃO ADICINADOS
    const dado = {
      name,
      price,
    }
    // console.log(dado);

    addProducts(dado);

    setName("");
    setPrice("");
  };

  return (
    <div className='flex flex-col min-h-screen p-0 m-0 bg-blue-200 text-gray-600'>
      <main className="flex-grow px-3 py-10">

        {/* #### SOBRE #### */}
        <div className='mb-10'>
          <button
            className='bg-blue-400 hover:bg-blue-400 px-4 py-0.5 rounded-xl shadow-sm hover:cursor-pointer text-gray-300'
            onClick={() => { setCollapse(!collapse) }}
          >
            Ler sobre
          </button>
          <div className={`p-10 ${(collapse)?"block":"hidden"} transition-all duration-500`}>
            <h1 className="text-2xl font-bold mb-4">Sobre o projeto</h1>
            <p>
              Este projeto é uma aplicação web desenvolvida em React com Hooks, com foco no consumo de APIs e integração com Firebase como banco de dados via APIs. Ele permite operações de listagem, adição e remoção de dados, oferecendo uma gestão dinâmica e eficiente.
            </p>
            <p className="mt-2">
              A interface foi construída com TailwindCSS, garantindo responsividade e uma experiência consistente em diferentes dispositivos. O projeto segue boas práticas de desenvolvimento em React, incluindo:
            </p>
            <ul className="list-disc list-inside mt-2">
              <li>Componentização e reutilização de código com Hooks;</li>
              <li>Gerenciamento de estado de forma eficiente;</li>
              <li>Validação e formatação de dados no front-end antes do envio para o back-end;</li>
              <li>Integração com Firebase via APIs para armazenamento e manipulação de dados.</li>
            </ul>
            <p className="mt-2">
              Este projeto demonstra como construir aplicações modernas em React, combinando front-end e back-end, com ênfase em <strong>consumo de APIs</strong>, interfaces responsivas e melhores práticas de desenvolvimento.
            </p>
          </div>
        </div>

        {/* #### CONSULTA #### */}
        <div className='bg-gray-100 max-w-300 mx-auto p-3 rounded-xl mb-5'>
          {loading && <p>Carregando ... </p>}
          {error && <p>{error}</p>}
          {(!error && !loading && products && products.length === 0) &&
            <p>Não há produtos para exibir. Por favor, adicione um produto.</p>
          }
          {(!error && !loading && products && products.length > 0) && products.map((product) => (
            <Products key={product.id} product={product} deleteProduct={deleteProduct}></Products>
          ))}
        </div>

        {/* #### ADICIONA #### */}
        <div className='bg-gray-100  max-w-300 mx-auto p-3 rounded-xl flex flex-col'>
          <form onSubmit={handleSubmit}>
            <div>
              <input
                type="text"
                name="name"
                value={name}
                onChange={(e) => { setName(e.target.value) }}
                placeholder='Nome produto'
                className={classInput}
              />
              <input
                type="number"
                name="price"
                value={price}
                onChange={(e) => { setPrice(e.target.value) }}
                placeholder='Valor produto'
                className={classInput}
              />
            </div>
            <div className='flex justify-end'>
              <button className='bg-blue-200 hover:bg-blue-300 px-4 py-0.5 rounded-xl shadow-sm  hover:cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed' disabled={loading}>{loading ? "Atualizando..." : "Adicionar"}</button>
            </div>
          </form>
        </div>

      </main>
    </div>
  );
}

export default App;
